import { render, staticRenderFns } from "./CreateProfileGetStarted.vue?vue&type=template&id=da794764&scoped=true"
import script from "./CreateProfileGetStarted.vue?vue&type=script&lang=js"
export * from "./CreateProfileGetStarted.vue?vue&type=script&lang=js"
import style0 from "./CreateProfileGetStarted.vue?vue&type=style&index=0&id=da794764&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da794764",
  null
  
)

export default component.exports